import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core"
import { UserAgentService } from "../../services/user-agent.service"
import { Observable, Subject } from "rxjs"
import { IWindowResizeEvent, WindowSizeService } from "../../services/window-size.service"
import { takeUntil, tap } from "rxjs/operators"
import { TooltipPlacementModel } from "../../models/tooltipPlacement.model"

@Component({
    selector: "app-link-button",
    templateUrl: "./link-button.component.html",
    styleUrls: ["link-button.component.scss"],
    standalone: false,
})
export class LinkButtonComponent implements OnInit, OnDestroy {
    @Input() icon: string
    @Input() marginTop: string
    @Input() marginBottom: string
    @Input() tooltip: string
    @Input() label: string
    @Input() classList: string
    @Input() hideLabelOnTablet
    @Input() hideLabelOnSmallDevices
    @Input() hideLabelOnMobile
    @Input() tooltipPlacement: TooltipPlacementModel
    @Input() disable: boolean = false
    @Output() trigger: EventEmitter<any> = new EventEmitter()
    private destroyed$: Subject<void> = new Subject<void>()
    innerWidth: number

    windowResizeEventObservable: Observable<IWindowResizeEvent> =
        this.windowSizeService.resize.pipe(
            takeUntil(this.destroyed$),
            tap((resizeEvent: IWindowResizeEvent) => (this.innerWidth = resizeEvent.innerWidth))
        )

    constructor(
        public userAgentService: UserAgentService,
        private windowSizeService: WindowSizeService
    ) {}

    ngOnInit() {
        this.windowResizeEventObservable.subscribe()
    }

    public onClick(event: MouseEvent) {
        event.preventDefault()
        if (!this.disable) {
            this.trigger.next(event)
        }
    }

    ngOnDestroy() {
        this.destroyed$.next()
        this.destroyed$.complete()
    }
}
